import type {Recruitment} from '../../../core/repositories/recruitingInfoRepository';
import {useGetRecruitmentList} from '../../../core/repositories/recruitmentRepository';

type Props = {
  companyId: number;
  recruitmentDetailId: number;
};

export const useOtherRecruitmentList = ({
  companyId,
  recruitmentDetailId,
}: Props) => {
  const {data, isLoading} = useGetRecruitmentList({
    companyIDs: [companyId],
  });

  const filteredOtherRecruitmentListData = (list: Recruitment[]) => {
    return list.filter(
      (recruitment) => recruitment.detailID !== recruitmentDetailId,
    );
  };

  const otherRecruitmentList =
    data?.ok && data.value.recruitments.length > 0
      ? filteredOtherRecruitmentListData(data.value.recruitments)
      : [];

  return {
    otherRecruitmentList,
    isLoadingOtherRecruitmentList: isLoading,
    hasOtherRecruitmentList: otherRecruitmentList.length > 0,
  };
};
